class Years {
  constructor(year) {
    this.year = year; 
  }
}

export default Years;